"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RenderApp;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
const recoil_1 = require("recoil");
const i18n_1 = __importDefault(require("./i18n"));
const analytics_package_1 = __importDefault(require("@alcumus/analytics-package"));
const environmentVariables_1 = __importDefault(require("../common/environmentVariables"));
const store_1 = __importDefault(require("store"));
const PrivateRoute_1 = require("../common/components/PrivateRoute/PrivateRoute");
const Router_1 = __importDefault(require("../common/Router"));
async function RenderApp() {
    const analytics = analytics_package_1.default.getInstance();
    if (environmentVariables_1.default.MIXPANEL_TOKEN) {
        analytics.initialize(environmentVariables_1.default.MIXPANEL_TOKEN);
        const firstName = store_1.default.get('user_first_name');
        const lastName = store_1.default.get('user_last_name');
        // If user is blocking 3rd party cookies, they would be tracked as "undefined_undefined"
        // This check is implemented so that the tracking ID falls back to device ID if cookies are blocked.
        if (firstName && lastName) {
            analytics.identify(`${firstName}_${lastName}`);
        }
    }
    const supportsHistory = 'pushState' in window.history;
    const RootElement = document.getElementById('root');
    let initializeState;
    // Todo: remove this await, add an root component that waits for i18n
    await i18n_1.default;
    if (typeof window !== 'undefined') {
        // @ts-ignore
        const preloadedState = window.__PRELOADED_STATE__ || {};
        const stateData = document.getElementById('stateData');
        initializeState = ({ set }) => {
            set(PrivateRoute_1.authorizationToken, preloadedState.portalToken?.accessToken);
            set(PrivateRoute_1.refreshToken, preloadedState.portalToken?.refreshToken);
            set(PrivateRoute_1.accessTokenExpiry, preloadedState.portalToken?.expiresIn);
        };
        if (stateData)
            document.head.removeChild(stateData);
        // @ts-ignore
    }
    react_dom_1.default.hydrate(react_1.default.createElement(react_router_dom_1.BrowserRouter, { forceRefresh: !supportsHistory },
        react_1.default.createElement(recoil_1.RecoilRoot, { initializeState: initializeState },
            react_1.default.createElement(Router_1.default, null))), RootElement);
}
